import type { QuestionSingleChoiceSchema } from '@repo/schemas/quiz/questionSingleChoice';

import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import { questionSingleChoiceSchema } from '@repo/schemas/quiz/questionSingleChoice';
import { useEffect } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { v4 as uuidv4 } from 'uuid';

export function useQuestionSingleForm(data?: QuestionSingleChoiceSchema) {
  const form = useForm<QuestionSingleChoiceSchema>({
    defaultValues: data,
    mode: 'onChange',
    resolver: standardSchemaResolver(questionSingleChoiceSchema),
  });

  //trigger validation on component mount
  useEffect(() => {
    form.trigger();
  }, []);

  const singleQuestionAnswers = useFieldArray<QuestionSingleChoiceSchema>({
    control: form.control,
    name: 'answers',
  });

  const toggleCorrect = (index: number): void => {
    const answers = form.getValues('answers');
    if (answers[index]?.correct) return;
    answers.forEach((_answer, answerIndex) => {
      form.setValue(`answers.${answerIndex}.correct`, answerIndex === index);
    });
  };

  const handleAddAnswer = (): void => {
    singleQuestionAnswers.append({
      id: uuidv4(),
      content: 'Nowa odpowiedź',
      correct: false,
      explanation: undefined,
    });
  };

  const handleRemoveAnswer = (index: number): void => {
    const isCorrect = form.getValues(`answers.${index}.correct`);

    if (isCorrect) {
      toast.error('Nie można usunąć poprawnej odpowiedzi, zmień inną odpowiedź na poprawną i spróbuj ponownie', {
        duration: 1500,
        closeButton: false,
        position: 'top-center',
      });
      return;
    }

    singleQuestionAnswers.remove(index);
  };

  return {
    form,
    singleQuestionAnswers,
    toggleCorrect,
    handleAddAnswer,
    handleRemoveAnswer,
  };
}
